import { Check, X } from "lucide-react";
import { PASSWORD_RULES, STRENGTH_META, passwordStrength } from "@/lib/password-strength";

export function PasswordField({
  label = "Password",
  value,
  onChange,
  placeholder = "••••••••",
  showMeter = true,
  autoComplete = "new-password",
  id,
}: {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  showMeter?: boolean;
  autoComplete?: string;
  id?: string;
}) {
  const { tier, score, passedRules } = passwordStrength(value);
  const meta = STRENGTH_META[tier];
  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
      <input
        id={id}
        type="password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className="h-10 w-full rounded-md border border-border bg-background px-3 text-sm focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
      />
      {showMeter && (
        <div className="mt-2 space-y-2">
          <div className="flex items-center gap-2">
            <div className="flex h-1.5 flex-1 gap-1 overflow-hidden rounded-full bg-border/60">
              {[0, 1, 2, 3].map((i) => (
                <div
                  key={i}
                  className={`h-full flex-1 rounded-full transition-colors ${i < score ? meta.bar : "bg-transparent"}`}
                />
              ))}
            </div>
            {meta.label && <span className={`text-[11px] font-semibold ${meta.color}`}>{meta.label}</span>}
          </div>
          <ul className="space-y-0.5 text-[11px]">
            {PASSWORD_RULES.map((r) => {
              const ok = passedRules[r.id];
              return (
                <li key={r.id} className={`flex items-center gap-1.5 ${ok ? "text-emerald-500" : "text-muted-foreground"}`}>
                  {ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
                  <span>{r.label}</span>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </label>
  );
}
